import { render, staticRenderFns } from "./targeting-form.vue?vue&type=template&id=1d014ddc&scoped=true"
import script from "./targeting-form.vue?vue&type=script&setup=true&lang=js"
export * from "./targeting-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./targeting-form.vue?vue&type=style&index=0&id=1d014ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d014ddc",
  null
  
)

export default component.exports